import { publicAssetsURL } from '#internal/nuxt/paths';export default publicAssetsURL("/assets/images/components/live-casino/no-data.png")